import axios from 'axios'
import {
  ITEM_LIST_REQUEST,
  ITEM_LIST_SUCCESS,
  ITEM_LIST_FAIL,
  ITEM_ALL_REQUEST,
  ITEM_ALL_SUCCESS,
  ITEM_ALL_FAIL,
  ITEM_ADD_REQUEST,
  ITEM_ADD_SUCCESS,
  ITEM_ADD_FAIL,
  ITEM_DELETE_REQUEST,
  ITEM_DELETE_SUCCESS,
  ITEM_DELETE_FAIL
} from '../constants/itemConstants'

import { API_URL } from '../apiUrl.js'

export const getItems =
  (pageNumberitem = '', keyword = '') =>
  async (dispatch) => {
    axios.defaults.withCredentials = true

    try {
      dispatch({ type: ITEM_LIST_REQUEST })

      const config = {
        headers: {
          'Content-Type': 'application/json'
        }
      }

      const { data } = await axios.get(`${API_URL}/item/list`, {
        ...config,
        params: { pageNumberitem, keyword }
      })

      dispatch({ type: ITEM_LIST_SUCCESS, payload: data })
    } catch (err) {
      dispatch({
        type: ITEM_LIST_FAIL,
        payload:
          err.response && err.response.data.message ?
            err.response.data.message
          : err.message
      })
    }
  }

export const getItemsall = () => async (dispatch) => {
  axios.defaults.withCredentials = true

  try {
    dispatch({ type: ITEM_ALL_REQUEST })

    const config = {
      headers: {
        'Content-Type': 'application/json'
      }
    }

    const { data } = await axios.get(`${API_URL}/item/all`, config)

    dispatch({ type: ITEM_ALL_SUCCESS, payload: data })
  } catch (err) {
    dispatch({
      type: ITEM_ALL_FAIL,
      payload:
        err.response && err.response.data.message ?
          err.response.data.message
        : err.message
    })
  }
}

export const addItem = (newitem) => async (dispatch, getState) => {
  axios.defaults.withCredentials = true

  try {
    dispatch({ type: ITEM_ADD_REQUEST })

    const {
      userLogin: { userInfo }
    } = getState()

    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userInfo.token}`
      }
    }

    const { data } = await axios.post(`${API_URL}/item/add`, newitem, config)

    dispatch({ type: ITEM_ADD_SUCCESS, payload: data })
  } catch (err) {
    dispatch({
      type: ITEM_ADD_FAIL,
      payload:
        err.response && err.response.data.message ?
          err.response.data.message
        : err.message
    })
  }
}

export const deleteItem = (id) => async (dispatch, getState) => {
  axios.defaults.withCredentials = true

  try {
    dispatch({ type: ITEM_DELETE_REQUEST })

    const {
      userLogin: { userInfo }
    } = getState()

    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userInfo.token}`
      }
    }

    const { data } = await axios.delete(`${API_URL}/item/del/${id}`, config)

    dispatch({ type: ITEM_DELETE_SUCCESS, payload: data })
  } catch (err) {
    dispatch({
      type: ITEM_DELETE_FAIL,
      payload:
        err.response && err.response.data.message ?
          err.response.data.message
        : err.message
    })
  }
}
